import React, { useState, useEffect, forwardRef, useRef, useImperativeHandle } from 'react';
import { Switch, Tooltip, Collapse, Row, Col, AutoComplete, InputNumber } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import { useHistory } from 'react-router-dom';
import './ClosingCost.css';

const ClosingCost = forwardRef(({ 
    initialClosingFee,
    initialConfig,
    onConfigChange,
    onTotalFeesChange,
    onAddLenderClick,
    configDisabled = false
}, ref) => {
    const history = useHistory()
    const sectionBRef = useRef(null)
    const sectionFRef = useRef(null)
    const sectionGRef = useRef(null)
    const [activeKeys, setActiveKeys] = useState(['0', '1'])
    const [cannotshop, setCannotshop] = useState(initialClosingFee?.canNotShopServices || [])
    const [canShop, setCanShop] = useState(initialClosingFee?.canShopServices || [])
    const [taxesandothergovernmentfees, setTaxesandothergovernmentfees] = useState(initialClosingFee?.taxesAndOtherGovernmentFees || [])
    const [prepaids, setPrepaids] = useState(initialClosingFee?.prepaids || [])
    const [initialescrowpaymentsatclosing, setInitialescrowpaymentsatclosing] = useState(initialClosingFee?.initialEscrowPaymentsAtClosing || [])
    const [other, setOther] = useState(initialClosingFee?.other || [])
    const [manualTooltipVisibleB, setManualTooltipVisibleB] = useState(
        initialConfig.enableCanNotShopServices && !initialConfig.isModified
    );
    const [manualTooltipVisibleF, setManualTooltipVisibleF] = useState(
        initialConfig.enablePrepaids && !initialConfig.isModified
    );
    const [manualTooltipVisibleG, setManualTooltipVisibleG] = useState(
        initialConfig.enableInitialEscrowPaymentsAtClosing && !initialConfig.isModified
    );
    const lodestarManualInputMessage = 'Lodestar does not provide fee data for this section. Consider using manual inputs.'
    const lodestarSwitchTooltipText = "Enable Lodestar for this section only."
    const lodestarSectionTooltipText = "The fees shown in this section are common examples. Actual fee items and amounts will be generated based on your specific loan and property location when you generate a rate quote."
    const lodestarCannotshopservices = [
        {
          "serviceName": "Appraisal fee",
          "estimateAmount": 0,
          "identifiedProvider": "",
          "contactInfo": ""
        },
        {
          "serviceName": "Credit report fee",
          "estimateAmount": 0,
          "identifiedProvider": "",
          "contactInfo": ""
        },
        {
          "serviceName": "Flood determination fee",
          "estimateAmount": 0,
          "identifiedProvider": "",
          "contactInfo": ""
        },
        {
          "serviceName": "MERS registration fee",
          "estimateAmount": 0,
          "identifiedProvider": "",
          "contactInfo": ""
        },
        {
          "serviceName": "Inspection fee",
          "estimateAmount": 0,
          "identifiedProvider": "",
          "contactInfo": ""
        },
        {
          "serviceName": "Tax service fee",
          "estimateAmount": 0,
          "identifiedProvider": "",
          "contactInfo": ""
        }
    ]
    const lodestarCanshopservices = [
        {
            "serviceName": "Title – Document preparation",
            "estimateAmount": 0,
            "identifiedProvider": "",
            "contactInfo": ""
        },
        {
            "serviceName": "Title – Escrow fee",
            "estimateAmount": 0,
            "identifiedProvider": "",
            "contactInfo": ""
        },
        {
            "serviceName": "Title – E-recording fee",
            "estimateAmount": 0,
            "identifiedProvider": "",
            "contactInfo": ""
        },
        {
            "serviceName": "Title – Lender’s title policy",
            "estimateAmount": 0,
            "identifiedProvider": "",
            "contactInfo": ""
        },
        {
            "serviceName": "Title – Processing fee",
            "estimateAmount": 0,
            "identifiedProvider": "",
            "contactInfo": ""
        },
        {
            "serviceName": "Title – Tax research fee",
            "estimateAmount": 0,
            "identifiedProvider": "",
            "contactInfo": ""
        }
    ]
    const lodestarTaxesandothergovernmentfees = [
        {
            "serviceName": "Recording fees and other taxes",
            "estimateAmount": 0,
            "identifiedProvider": "",
            "contactInfo": ""
        }
    ]
    const lodestarPrepaids = [
        {
            "serviceName": "Homeowner's insurance premium (months)",
            "estimateAmount": 0,
            "identifiedProvider": "",
            "contactInfo": ""
        },
        {
            "serviceName": "Mortgage insurance premium (months)",
            "estimateAmount": 0,
            "identifiedProvider": "",
            "contactInfo": ""
        },
        {
            "serviceName": "Prepaid interest ( per day for days @ )",
            "estimateAmount": 0,
            "identifiedProvider": "",
            "contactInfo": ""
        },
        {
            "serviceName": "Property taxes (months)",
            "estimateAmount": 0,
            "identifiedProvider": "",
            "contactInfo": ""
        }
    ]
    const lodestarInitialescrowpaymentsatclosing = [
        {
            "serviceName": "Homeowner's insurance per month for mo.",
            "estimateAmount": 0,
            "identifiedProvider": "",
            "contactInfo": ""
        },
        {
            "serviceName": "Mortgage insurance per month for mo.",
            "estimateAmount": 0,
            "identifiedProvider": "",
            "contactInfo": ""
        },
        {
            "serviceName": "Property taxes per month for mo.",
            "estimateAmount": 0,
            "identifiedProvider": "",
            "contactInfo": ""
        }
    ]
    const lodestarOther = [
        {
            "serviceName": "Title - Owner's title policy (optional)",
            "estimateAmount": 0,
            "identifiedProvider": "",
            "contactInfo": ""
        }
    ]
    useEffect(() => {
        setManualTooltipVisibleB(initialConfig.enableCanNotShopServices && !initialConfig.isModified);
    }, [initialConfig.enableCanNotShopServices, initialConfig.isModified]);
      
    useEffect(() => {
        setManualTooltipVisibleF(initialConfig.enablePrepaids && !initialConfig.isModified);
    }, [initialConfig.enablePrepaids, initialConfig.isModified]);
      
    useEffect(() => {
        setManualTooltipVisibleG(initialConfig.enableInitialEscrowPaymentsAtClosing && !initialConfig.isModified);
    }, [initialConfig.enableInitialEscrowPaymentsAtClosing, initialConfig.isModified]);
    useEffect(() => {
        setCannotshop(initialClosingFee?.canNotShopServices || []);
        setCanShop(initialClosingFee?.canShopServices || []);
        setTaxesandothergovernmentfees(initialClosingFee?.taxesAndOtherGovernmentFees || []);
        setPrepaids(initialClosingFee?.prepaids || []);
        setInitialescrowpaymentsatclosing(initialClosingFee?.initialEscrowPaymentsAtClosing || []);
        setOther(initialClosingFee?.other || []);
    }, [
        initialClosingFee?.canNotShopServices,
        initialClosingFee?.canShopServices,
        initialClosingFee?.taxesAndOtherGovernmentFees,
        initialClosingFee?.prepaids,
        initialClosingFee?.initialEscrowPaymentsAtClosing,
        initialClosingFee?.other
    ])
    // 计算总费用的函数
    const calculateTotalFees = () => {
        const calculateArrayTotal = (arr) => {
            return arr.reduce((sum, item) => sum + (Number(item.estimateAmount) || 0), 0)
        }
    
        const total = 
            // 只计算 Use Lodestar 为 false 的项
            (!initialConfig.enableCanNotShopServices ? calculateArrayTotal(cannotshop) : 0) +
            (!initialConfig.enableCanShopServices ? calculateArrayTotal(canShop) : 0) +
            (!initialConfig.enableTaxesAndOtherGovernmentFees ? calculateArrayTotal(taxesandothergovernmentfees) : 0) +
            (!initialConfig.enablePrepaids ? calculateArrayTotal(prepaids) : 0) +
            (!initialConfig.enableInitialEscrowPaymentsAtClosing ? calculateArrayTotal(initialescrowpaymentsatclosing) : 0) +
            (!initialConfig.enableOther ? calculateArrayTotal(other) : 0) +
            calculateArrayTotal(initialClosingFee?.originationCharges || [])
    
        return total
    }
    
    // 监听费用变化并通知父组件
    useEffect(() => {
        if (onTotalFeesChange) {
            onTotalFeesChange(calculateTotalFees())
        }
    }, [
        cannotshop,
        canShop,
        taxesandothergovernmentfees,
        prepaids,
        initialescrowpaymentsatclosing,
        other,
        initialClosingFee?.originationCharges,
        // 添加 initialConfig 的依赖
        initialConfig.enableCanNotShopServices,
        initialConfig.enableCanShopServices,
        initialConfig.enableTaxesAndOtherGovernmentFees,
        initialConfig.enablePrepaids,
        initialConfig.enableInitialEscrowPaymentsAtClosing,
        initialConfig.enableOther
    ])

    // 暴露方法给父组件
    useImperativeHandle(ref, () => ({
        getClosingFee: () => {
            const validCosts = (costs) => (Array.isArray(costs) ? costs : []).filter(
                item => item && typeof item.serviceName === 'string' && item.serviceName.trim() !== ''
            );
            return {
                originationCharges: validCosts(initialClosingFee?.originationCharges),
                canNotShopServices: validCosts(cannotshop),
                canShopServices: validCosts(canShop),
                taxesAndOtherGovernmentFees: validCosts(taxesandothergovernmentfees),
                prepaids: validCosts(prepaids),
                initialEscrowPaymentsAtClosing: validCosts(initialescrowpaymentsatclosing),
                other: validCosts(other)
            }
        }
    }))

    const customHeader = (type) => {
        return (
            <div className='closing-cost-header'>
                {type === 'loan' ? 'Loan costs' : 'Other costs'}
            </div>   
        )
    }

    const handleConfigChange = (key) => {
        if (onConfigChange) {
            onConfigChange({
                ...initialConfig,
                [key]: !initialConfig[key]
            });
        }
    };

    // 通用的cost处理函数
    const handleCostChange = (costs, setCosts, index, field, value) => {
        const newCosts = [...costs];
        newCosts[index] = {
            ...newCosts[index],
            [field]: value
        };
        setCosts(newCosts);
    };

    const removeCost = (costs, setCosts, index) => {
        const newCosts = [...costs];
        newCosts.splice(index, 1);
        setCosts(newCosts);
    };

    const addCost = (costs, setCosts) => {
        setCosts([...costs, { serviceName: "", estimateAmount: 0, identifiedProvider: "", contactInfo: "" }]);
    };

    const handleAddLenderClick = (e) => {
        if (onAddLenderClick) {
            onAddLenderClick(e)
        } else {
            history.push('/app/management?select=lender')
        }
    }
    const renderCostList = (costs, setCosts, isDisabled, onRemove) => {
        // 根据 isDisabled 决定使用哪个数据源
        const displayCosts = isDisabled ? 
            (costs === cannotshop ? lodestarCannotshopservices :
             costs === canShop ? lodestarCanshopservices :
             costs === taxesandothergovernmentfees ? lodestarTaxesandothergovernmentfees :
             costs === prepaids ? lodestarPrepaids :
             costs === initialescrowpaymentsatclosing ? lodestarInitialescrowpaymentsatclosing :
             costs === other ? lodestarOther : costs)
            : costs;
    
        return (
            <>
                <Row gutter={48}>
                    {displayCosts.map((element, index) => (
                        <Col sm={12} span={24} key={index}>
                            <Row gutter={2}>
                                <Col sm={14} span={24}>
                                    <AutoComplete
                                        name="serviceName"
                                        className="estFee-select"
                                        style={{
                                            width: "100%",
                                            height: 50,
                                            marginBottom: 12
                                        }}
                                        disabled={isDisabled}
                                        value={element.serviceName || ""}
                                        filterOption={(inputValue, option) =>
                                            option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                                        }
                                        onChange={(value) => handleCostChange(costs, setCosts, index, 'serviceName', value)}
                                    />
                                </Col>
                                <Col sm={8} span={24}>
                                    <InputNumber
                                        className="estFee-input"
                                        name="estimateAmount"
                                        formatter={(value) => {
                                            if (isDisabled) {
                                                return '$ -';
                                            }
                                            if (value === null || value === undefined || value === '') {
                                                return '$ 0';
                                            }
                                            return `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                                        }}
                                        parser={(value) => value?.replace(/\$\s?|(,*)/g, '')}
                                        value={element.estimateAmount}
                                        disabled={isDisabled}
                                        onChange={(value) => handleCostChange(costs, setCosts, index, 'estimateAmount', value)}
                                    />
                                </Col>
                                <Col sm={2} span={24}>
                                    {
                                        !isDisabled && (
                                            <div style={{ display: 'flex', alignItems: 'center', height: '100%', paddingLeft: 14, paddingBottom: 12 }}>
                                                <img 
                                                    style={{ cursor: 'pointer' }} 
                                                    src="/images/closingCost-remove.svg" 
                                                    onClick={() => onRemove(index)} 
                                                />
                                            </div>
                                        )
                                    }
                                </Col>
                            </Row>
                        </Col>
                    ))}
                </Row>
                {
                    !isDisabled && (
                        <div className="estFee-add-more-wrapper">
                            <div className="estFee-add-more">
                                <img src="/images/closingCost-add.svg" />
                                <div onClick={() => addCost(costs, setCosts)}>Add more</div>
                            </div>
                        </div>
                    )
                }
            </>
        );
    };

    return (
        <div className='closing-cost-wrapper'>
            <Collapse 
                className='closing-cost-collapse' 
                expandIcon={({ isActive }) => <img className={`${isActive ? 'expand' : ''} collapse-icon`} src="/images/dti-calculator-arrow.svg" /> } 
                expandIconPosition="end"
                defaultActiveKey={['0', '1']}
                activeKey={activeKeys}
                onChange={setActiveKeys}
            >
                <Collapse.Panel className='closing-cost-collapse-item' header={customHeader('loan')}>
                    <div className="closing-cost-section">
                        <div className="closing-cost-section-title">
                            <div className='closing-cost-section-title-name'>A. Origination charges</div>
                        </div>
                        <div className="closing-cost-section-content">
                            <div className='closing-cost-section-content-tips'>The fees in this section are defined by lender. Please view and edit in <span className='closing-cost-section-content-link' onClick={handleAddLenderClick}>Lenders</span></div>
                        </div>
                    </div>
                    <div className="closing-cost-section" ref={sectionBRef}>
                        <div className="closing-cost-section-title">
                            <div className='closing-cost-section-title-name'>
                                <div>B. Services you can't shop for</div>
                                {activeKeys.includes('0') && initialConfig.enableCanNotShopServices && (
                                    initialConfig.isModified ? (
                                        <Tooltip
                                            overlayClassName="closing-cost-section-tooltip"
                                            placement="bottomRight"
                                            title={lodestarSectionTooltipText}
                                        >
                                        <img src="/images/closingCost-info.svg" />
                                        </Tooltip>
                                    ) : (
                                        <Tooltip
                                            overlayClassName="closing-cost-section-tooltip not-provided"
                                            placement="bottomLeft"
                                            open={manualTooltipVisibleB ? true : undefined} // 只在初始时受控
                                            getPopupContainer={() => sectionBRef.current}
                                            title={
                                                <div style={{ display: 'flex', alignItems: 'self-start', gap: 8 }}>
                                                    <img src="/images/lodestar-not-provided.svg" />
                                                    <div className='closing-cost-section-tooltip-message'>{lodestarManualInputMessage}</div>
                                                    <CloseOutlined 
                                                        onClick={e => {
                                                            e.stopPropagation();
                                                            setManualTooltipVisibleB(false);
                                                        }}
                                                        style={{ fontSize: 12, color: '#545459', cursor: 'pointer', fontWeight: 'bold' }} 
                                                    />
                                                </div>
                                            }
                                        >
                                            <img src="/images/closingCost-info.svg" />
                                        </Tooltip>
                                    )
                                )}
                            </div>
                        </div>
                        <div className="closing-cost-section-content">
                            {renderCostList(
                                cannotshop,
                                setCannotshop,
                                false,
                                (index) => removeCost(cannotshop, setCannotshop, index)
                            )}
                        </div>
                    </div>
                    <div className="closing-cost-section">
                        <div className="closing-cost-section-title">
                            <div className='closing-cost-section-title-name'>
                                <div>C. Services you can shop for</div>
                                <Tooltip 
                                    overlayClassName="closing-cost-section-tooltip" 
                                    placement="bottomRight" 
                                    title={lodestarSectionTooltipText}
                                >
                                    <img src="/images/closingCost-info.svg" />
                                </Tooltip>
                            </div>
                            <div className="closing-cost-section-title-switch">
                                <Tooltip 
                                    overlayClassName="closing-cost-section-tooltip" 
                                    placement="bottom" 
                                    title={lodestarSwitchTooltipText}
                                >
                                    <Switch 
                                        checked={initialConfig.enableCanShopServices} 
                                        disabled={configDisabled}
                                        onChange={() => handleConfigChange('enableCanShopServices')} 
                                    />
                                </Tooltip>
                                Use Lodestar
                            </div>
                        </div>
                        <div className="closing-cost-section-content">
                            {renderCostList(
                                canShop,
                                setCanShop,
                                initialConfig.enableCanShopServices,
                                (index) => removeCost(canShop, setCanShop, index)
                            )}
                        </div>
                    </div>
                </Collapse.Panel>
                <Collapse.Panel className='closing-cost-collapse-item' header={customHeader('other')}>
                    <div className="closing-cost-section">
                        <div className="closing-cost-section-title">
                            <div className='closing-cost-section-title-name'>
                                <div>E. Taxes and other government fees</div>
                                <Tooltip 
                                    overlayClassName="closing-cost-section-tooltip" 
                                    placement="bottomRight" 
                                    title={lodestarSectionTooltipText}
                                >
                                    <img src="/images/closingCost-info.svg" />
                                </Tooltip>
                            </div>
                            <div className="closing-cost-section-title-switch">
                                <Tooltip 
                                    overlayClassName="closing-cost-section-tooltip" 
                                    placement="bottom" 
                                    title={lodestarSwitchTooltipText}
                                >
                                    <Switch 
                                        checked={initialConfig.enableTaxesAndOtherGovernmentFees} 
                                        disabled={configDisabled}
                                        onChange={() => handleConfigChange('enableTaxesAndOtherGovernmentFees')} 
                                    />
                                </Tooltip>
                                Use Lodestar
                            </div>
                        </div>
                        <div className="closing-cost-section-content">
                            {renderCostList(
                                taxesandothergovernmentfees,
                                setTaxesandothergovernmentfees,
                                initialConfig.enableTaxesAndOtherGovernmentFees,
                                (index) => removeCost(taxesandothergovernmentfees, setTaxesandothergovernmentfees, index)
                            )}
                        </div>
                    </div>
                    <div className="closing-cost-section" ref={sectionFRef}>
                        <div className="closing-cost-section-title">
                            <div className='closing-cost-section-title-name'>
                                <div>F. Prepaid</div>
                                {activeKeys.includes('1') && initialConfig.enablePrepaids && (
                                    initialConfig.isModified ? (
                                        <Tooltip
                                        overlayClassName="closing-cost-section-tooltip"
                                        placement="bottomRight"
                                        title={lodestarSectionTooltipText}
                                        >
                                        <img src="/images/closingCost-info.svg" />
                                        </Tooltip>
                                    ) : (
                                        <Tooltip
                                            overlayClassName="closing-cost-section-tooltip not-provided"
                                            placement="topLeft"
                                            open={manualTooltipVisibleF ? true : undefined} // 只在初始时受控
                                            getPopupContainer={() => sectionFRef.current}
                                            title={
                                                <div style={{ display: 'flex', alignItems: 'self-start', gap: 8 }}>
                                                    <img src="/images/lodestar-not-provided.svg" />
                                                    <div className='closing-cost-section-tooltip-message'>{lodestarManualInputMessage}</div>
                                                    <CloseOutlined 
                                                        onClick={e => {
                                                            e.stopPropagation();
                                                            setManualTooltipVisibleF(false);
                                                        }}
                                                        style={{ fontSize: 12, color: '#545459', cursor: 'pointer', fontWeight: 'bold' }} 
                                                    />
                                                </div>
                                            }
                                        >
                                            <img src="/images/closingCost-info.svg" />
                                        </Tooltip>
                                    )
                                )}
                            </div>
                        </div>
                        <div className="closing-cost-section-content">
                            {renderCostList(
                                prepaids,
                                setPrepaids,
                                false,
                                (index) => removeCost(prepaids, setPrepaids, index)
                            )}
                        </div>
                    </div>
                    <div className="closing-cost-section" ref={sectionGRef}>
                        <div className="closing-cost-section-title">
                            <div className='closing-cost-section-title-name'>
                                <div>G. Initial Escrow payment at closing</div>
                                {activeKeys.includes('1') && initialConfig.enableInitialEscrowPaymentsAtClosing && (
                                    initialConfig.isModified ? (
                                        <Tooltip
                                        overlayClassName="closing-cost-section-tooltip"
                                        placement="bottomRight"
                                        title={lodestarSectionTooltipText}
                                        >
                                        <img src="/images/closingCost-info.svg" />
                                        </Tooltip>
                                    ) : (
                                        <Tooltip
                                            overlayClassName="closing-cost-section-tooltip not-provided"
                                            placement="topLeft"
                                            open={manualTooltipVisibleG ? true : undefined} // 只在初始时受控
                                            getPopupContainer={() => sectionGRef.current}
                                            title={
                                                <div style={{ display: 'flex', alignItems: 'self-start', gap: 8 }}>
                                                    <img src="/images/lodestar-not-provided.svg" />
                                                    <div className='closing-cost-section-tooltip-message'>{lodestarManualInputMessage}</div>
                                                    <CloseOutlined 
                                                        onClick={e => {
                                                            e.stopPropagation();
                                                            setManualTooltipVisibleG(false);
                                                        }}
                                                        style={{ fontSize: 12, color: '#545459', cursor: 'pointer', fontWeight: 'bold' }} 
                                                    />
                                                </div>
                                            }
                                        >
                                            <img src="/images/closingCost-info.svg" />
                                        </Tooltip>
                                    )
                                )}
                            </div>
                        </div>
                        <div className="closing-cost-section-content">
                            {renderCostList(
                                initialescrowpaymentsatclosing,
                                setInitialescrowpaymentsatclosing,
                                false,
                                (index) => removeCost(initialescrowpaymentsatclosing, setInitialescrowpaymentsatclosing, index)
                            )}
                        </div>
                    </div>
                    <div className="closing-cost-section">
                        <div className="closing-cost-section-title">
                            <div className='closing-cost-section-title-name'>
                                <div>H. Other</div>
                                <Tooltip 
                                    overlayClassName="closing-cost-section-tooltip" 
                                    placement="bottomRight" 
                                    title={lodestarSectionTooltipText}
                                >
                                    <img src="/images/closingCost-info.svg" />
                                </Tooltip>
                            </div>
                            <div className="closing-cost-section-title-switch">
                                <Tooltip 
                                    overlayClassName="closing-cost-section-tooltip" 
                                    placement="bottom" 
                                    title={lodestarSwitchTooltipText}
                                >
                                    <Switch 
                                        checked={initialConfig.enableOther} 
                                        disabled={configDisabled}
                                        onChange={() => handleConfigChange('enableOther')} 
                                    />
                                </Tooltip>
                                Use Lodestar
                            </div>
                        </div>
                        <div className="closing-cost-section-content">
                            {renderCostList(
                                other,
                                setOther,
                                initialConfig.enableOther,
                                (index) => removeCost(other, setOther, index)
                            )}
                        </div>
                    </div>
                </Collapse.Panel>
            </Collapse>
        </div>
    );
});

export default ClosingCost; 
